import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { builtFor, notFor } from '../data/content';
import { Reveal } from './showcase/Reveal';
import { FunnelStrip } from './showcase/FunnelStrip';
export function WhoItIsFor() {
  return <section id="fit" aria-labelledby="fit-title" className="border-b border-white/5 bg-ink-800" data-id="element-447" data-mp="d590tysxd9bx">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-448" data-mp="83tbhujpsgnq">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-449" data-mp="15swfyybff7r6">
          Fit
        </p>
        <h2 id="fit-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-450" data-mp="10v3c4bxlipu2">
          Who it is for.
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-451" data-mp="qy8b9mduodcm">
          This is a response system for teams with real lead volume and real lead spend. If
          the phone is already ringing and appointments are the bottleneck, you are in the
          right place. If lead flow itself is the problem, we will tell you straight.
        </p>

        <Reveal className="mt-12" data-id="element-452" data-mp="g65z2wximsvt">
          <FunnelStrip data-id="element-453" data-mp="g54oetkew8em" />
        </Reveal>

        <div className="mt-5 grid gap-5 md:grid-cols-2" data-id="element-454" data-mp="1agf14bw4ptq">
          <div className="rounded-xl border border-brand/35 bg-ink-700 p-7 sm:p-8" data-id="element-455" data-mp="1c16gl2wrsnd">
            <h3 className="font-display text-xl font-semibold tracking-tight text-brand" data-id="element-456" data-mp="676rzisef5ax">
              Built for
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-457" data-mp="3tdr0p6s8hhvm">
              {builtFor.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white/75" data-id="element-458" data-mp="3tfk9armeqc69">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-459" data-mp="3emqhq7tv25l8" />
                  <span className="leading-relaxed" data-id="element-460" data-mp="35p7rmp1d112h">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-white/10 bg-ink-700 p-7 sm:p-8" data-id="element-461" data-mp="39oyo99dkibex">
            <h3 className="font-display text-xl font-semibold tracking-tight text-white/70" data-id="element-462" data-mp="1g8lymlpkl0ik">
              Not for
            </h3>
            <ul className="mt-6 space-y-4" data-id="element-463" data-mp="1behpbvsu0geb">
              {notFor.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white/55" data-id="element-464" data-mp="16f557itchnff">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-white/35" aria-hidden="true" data-id="element-465" data-mp="11jy6yqiuhaxw" />
                  <span className="leading-relaxed" data-id="element-466" data-mp="1u6an03iuipsd">{item}</span>
                </li>)}
            </ul>
            <p className="mt-7 border-t border-white/10 pt-6 text-sm leading-relaxed text-white/70" data-id="element-467" data-mp="1p6o87pndd1hg">
              We do not sell leads. We stop you from losing the ones you already pay for.
            </p>
          </div>
        </div>
      </div>
    </section>;
}